import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { RootReducer, AppDispatch } from './store'

export const AppUseDispatch = () => useDispatch<AppDispatch>()
export const AppUseSelector: TypedUseSelectorHook<RootReducer> = useSelector
